/**
 * pages/EndOfDayPage.jsx · v2.7.56+E33.3
 * ═════════════════════════════════════════════════════════════════
 * Dedicated route `/end-of-day` that renders the End-of-Day Deposit
 * form as its own page. Reached from:
 *   • Driver Dashboard tile (data-testid='tile-eod')
 *   • Driver Profile shortcut card (data-testid='profile-eod-link')
 *
 * The heavy lifting (form state, live totals, POST /api/driver/deposits,
 * receipt upload, history) lives in the shared component
 * <EndOfDayDepositCard/>. Passing `defaultOpen` here forces the card
 * pre-expanded so drivers land directly on the fields.
 */
import Layout from "@/components/Layout";
import EndOfDayDepositCard from "@/components/driver/EndOfDayDepositCard";

export default function EndOfDayPage() {
  return (
    <Layout title="End of Day Deposit" back={true}>
      <div className="max-w-2xl mx-auto" data-testid="eod-page">
        <EndOfDayDepositCard defaultOpen={true} hideToggleChevron={false} />
      </div>
    </Layout>
  );
}
